import { useQueryContentBlocks } from 'graphql/query/useQueryContentBlocks';
import { ContentBlock } from 'graphql/types/ContentBlock';

const DEFAULT_SHOP = 'ism';

export const useArticles = (type: string) => {
  const host = process.env.REACT_APP_REST_HOST;
  const { data } = useQueryContentBlocks({ variables: { type } });
  const getPath = ({ shop, slug }: ContentBlock) =>
    `${host}/${shop || DEFAULT_SHOP}/articles/${type}/${slug}`;
  const artilces = data?.contentBlocks?.items || [];

  return { getPath, artilces };
};
